import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
   <GoogleOAuthProvider clientId="your-client-id">
    <App />
  </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
